import React from 'react';

import { useNavigate } from 'react-router-dom';

import Tooltip from '@mui/material/Tooltip';

import ClickableComponent from 'components/Common/ClickableComponent';
import LogoutIcon from 'components/Common/Icons/LogoutOutlined';
import ShadowButton from 'components/Common/ShadowButton';
import WithPopover from 'components/Common/WithPopover';
import useModal from 'hooks/useModal';

import { LOGOUT } from 'routes/constants';

import s from './Logout.css';

const LogoutButton = () => {
  const navigate = useNavigate();
  const { hideModal } = useModal();

  return (
    <WithPopover
      clickable
      hideArrow
      classes={{
        paper: s.popover,
      }}
      popover={() => (
        <>
          <h6 className={s.logoutText}>
            Are you sure you want to log out of SchooLinks?
          </h6>
          <div className={s.dFlex}>
            <ShadowButton
              label="No, stay here"
              classes={{
                root: s.cancelPopoverBtn,
              }}
            />
            <ShadowButton
              iconDirection="right"
              color="gray"
              icon={<LogoutIcon />}
              onClick={() => {
                hideModal();
                navigate(LOGOUT);
              }}
              label="Yes, log me out"
              classes={{
                root: s.logoutShadowBtn,
              }}
            />
          </div>
        </>
      )}
      render={() => (
        <Tooltip arrow title="Sign off">
          <ClickableComponent key="logout-btn" className={s.logoutBtnWrapper}>
            <div className={s.logoutBtn}>
              <LogoutIcon />
            </div>
          </ClickableComponent>
        </Tooltip>
      )}
    />
  );
};

export default LogoutButton;
